import { Account, AccountSummary } from "@src/types";
import {
  formatDataObj,
  recursiveCamelCaseCipher,
  snakeCaseCipher,
} from "./common";
import request from "../request";

export const getAccountSummary = (accountId: number): Promise<AccountSummary> =>
  request
    .get(`/rest/accounts_summary`)
    .set("Accept", "application/json")
    .query({ id: `eq.${accountId}`, select: "id,name,users" })
    .then(({ body }) => recursiveCamelCaseCipher(body)[0]);

export const getAccount = (id: string | number): Promise<Account> =>
  request
    .get(`/rest/accounts`)
    .set("Accept", "application/json")
    .query({ id: `eq.${id}` })
    .then(({ body }) => recursiveCamelCaseCipher(body)[0]);

export const createNewAccount = (
  newAccount: Partial<Partial<Exclude<Account, "id">>>
) =>
  request.post("/rest/accounts").send(
    formatDataObj(newAccount, snakeCaseCipher, {
      allowNulls: true,
      allowUnknownKeys: false,
    })
  );
